import script from "./TicketListView.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketListView.vue?vue&type=script&setup=true&lang=js"

import "./TicketListView.vue?vue&type=style&index=0&id=9d512acc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d512acc"]])

export default __exports__